import { render, staticRenderFns } from "./TopCompanies.vue?vue&type=template&id=58d35574&scoped=true"
import script from "./TopCompanies.vue?vue&type=script&lang=js"
export * from "./TopCompanies.vue?vue&type=script&lang=js"
import style0 from "./TopCompanies.vue?vue&type=style&index=0&id=58d35574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d35574",
  null
  
)

export default component.exports